"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

// For each column grouping get the groups that contain a specific ID, or the group Unmapped if it has no groups
var getGroupsThatContainId = function getGroupsThatContainId(_ref) {
  var columnGroupings = _ref.columnGroupings,
      id = _ref.id;
  return columnGroupings.map(function (grouping) {
    var values = grouping.groups.filter(function (group) {
      return group.values.includes(id);
    }).map(function (group) {
      return {
        label: group.name,
        id: group.id
      };
    });
    return {
      name: grouping.name,
      memberName: grouping.memberName,
      values: values.length ? values : [{
        label: "Unmapped",
        id: ""
      }]
    };
  });
};

var CATEGORY_ALL = {
  name: "All",
  disabled: false
};
var CATEGORY_NONE = {
  name: "None",
  disabled: false
};

var columnsWithGroupings = function columnsWithGroupings(_ref2) {
  var xAxisCategories = _ref2.xAxisCategories,
      dataSeries = _ref2.dataSeries,
      columnGroupings = _ref2.columnGroupings;
  return xAxisCategories.map(function (e, ix) {
    return {
      value: e.label,
      categories: [].concat.apply([CATEGORY_ALL.name], dataSeries.filter(function (ds) {
        return ds.data.some(function (v) {
          return v.x === ix;
        });
      }).map(function (ds) {
        return ds.info.name;
      })),
      groupings: getGroupsThatContainId({
        columnGroupings: columnGroupings,
        id: e.id
      })
    };
  });
}; //columnGroupsPropTypes


var main = function main(_ref3) {
  var _ref3$heatmapData = _ref3.heatmapData,
      xAxisCategories = _ref3$heatmapData.xAxisCategories,
      dataSeries = _ref3$heatmapData.dataSeries,
      columnGroupings = _ref3.columnGroupings;
  return {
    //this could be inferred but is convenient to pass through
    groupingNames: columnGroupings.map(function (e) {
      return e.name;
    }),
    //This can't be inferred from the data later, because there might not be any columns with some category
    //(Happens when there's an empty data series)
    categories: [].concat([CATEGORY_ALL], [CATEGORY_NONE]),
    categoryCheckboxes: [].concat.apply([], dataSeries.map(function (ds) {
      return {
        name: ds.info.name,
        disabled: !ds.data.length
      };
    }).reverse()),
    data: columnsWithGroupings({
      xAxisCategories: xAxisCategories,
      dataSeries: dataSeries,
      columnGroupings: columnGroupings
    })
  };
};

var _default = main;
exports["default"] = _default;